import { module } from 'modujs';
const axios = require( 'axios' );

export default class extends module {
    constructor(m) {
        super(m);

        let currentDate = new Date();
        let day = String(currentDate.getDate()).padStart(2, '0');
        let month = String(currentDate.getMonth() + 1).padStart(2, '0');
        let year = String(currentDate.getFullYear());
        let formattedDate = `${year}-${month}-${day}`;
        //formattedDate = '2023-09-01';

        this.priceCont = this.$( 'price-cont' )[0];
        this.price =  this.$( 'price' )[0];
        this.noPrice =  this.$( 'no-price' )[0];



        var data = new FormData();
        data.append('room', this.el.dataset.roomCode);
        data.append('property', this.el.dataset.property);
        data.append('checkin', formattedDate );
        data.append('action', 'room_availability');

        axios.post(THEME_OBJ.ajaxURL, data).then(response => {

            const data = response.data;
            if (data.error_code === 'OK' ) {
                const rates = data.data.rates;
                let prices = [];
                if ( rates.length === 1) {
                    this.showPrice( rates[0].pricing.price );
                } else if ( rates.length > 1 ) {
                    for (let i = 0; i < rates.length; i++) {
                        prices.push(rates[i].pricing.price);
                    }
                    this.showPrice( Math.min(...prices) );
                } else {
                    this.showNoPrice();
                }
            } else {
                this.showNoPrice();
            }
        })



    }
    showPrice( price ){
        this.el.classList.remove( 'hidden' );
        this.priceCont.classList.remove( 'hidden' );
        this.price.textContent = price;
    }
    showNoPrice(){
        //this.noPrice.classList.remove( 'hidden' );
    }
    init() {}
    destroy(){}
}
